<template>
  <section id="chatChannels" class="custom-chat-channels">
    <div class="row custom-row">
      <div class="col-md-11 custom-group-title">
        <span>Chat Sessions</span>
      </div>
      <div class="col-md-1">
        <div class="custom-close" @click="closeChannels"><i class="fas fa-times"></i></div>
      </div>
    </div>
    <div class="row custom-group-row">
      <div class="col-md-12 md page-content channels-content">
        <div v-if="$loading.isLoading('getChannels')">loading...</div>
        <div v-else class="channels">
          <div v-if="isCenter || isDispatch" :key="isRender">
            <div v-for="firm in firmCounts" :key="firm.firm">
              <button
                :id="`accordion-${firm.firm}`"
                class="accordion btn btn-link btn-block custom-accordion"
                @click="toggleAccordion(firm.firm)"
              >
                <div class="row">
                  <div class="col">
                    <span>{{ firm.name }}</span>
                    <span class="badge-unread custom-unread" v-show="firm.unreadCount > 0">{{
                      firm.unreadCount
                    }}</span>
                  </div>
                </div>
              </button>
              <div :id="`panel-${firm.firm}`" class="accordion-panel">
                <div
                  v-for="(item, idx) in firmChannels(firm)"
                  :key="idx"
                  class="group"
                  @click="showMessages(item)"
                >
                  <div class="group-content">
                    <div class="group-name">
                      <span>#{{ item.calibrateEvent }} - RO {{ item.ronumber }}</span>
                      <span class="badge-unread custom-unread" v-show="item.unreadCount > 0">{{
                        item.unreadCount
                      }}</span>
                    </div>
                    <div class="group-info">
                      <!-- <div><i class="fas fa-users"></i><span class="group-member-count">{{ item.memberCount }}</span></div> -->
                      <div class="group-footer">
                        <span class="group-firm">{{ isCenter ? item.firmName : '' }}</span>
                        <span class="group-created">{{ vehicleInfo(item) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              v-for="(item, idx) in channels"
              :key="idx"
              class="group"
              @click="showMessages(item)"
            >
              <div class="group-content">
                <div class="group-name">
                  <span>RO# {{ item.ronumber }} - #{{ item.calibrateEvent }}</span>
                  <span class="badge-unread custom-unread" v-show="item.unreadCount > 0">{{
                    item.unreadCount
                  }}</span>
                </div>
                <div class="group-info">
                  <!-- <div><i class="fas fa-users"></i><span class="group-member-count">{{ item.memberCount }}</span></div> -->
                  <div class="group-footer">
                    <span class="group-firm">{{ isCenter ? item.firmName : '' }}</span>
                    <span class="group-created">{{ vehicleInfo(item) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import globals from '@/plugins/globals'
// import _ from 'lodash'
export default {
  name: 'chat-groups',
  data() {
    return {
      isRender: 0
    }
  },
  mounted() {
    globals.dragElement(document.getElementById('chatChannels'))
    this.$eventBus.$on('chat-refresh-groups', this.refreshChannels)
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['channels', 'firmCounts']),
    isShop() {
      let _is = false
      if (this.profile.roles[0] === 4 || this.profile.roles[0] === 5) {
        _is = true
      }
      return _is
    },
    isCenter() {
      let _is = false
      if (this.profile.roles[0] === 8 || this.profile.roles[0] === 9) {
        _is = true
      }
      return _is
    },
    isDispatch() {
      let _is = false
      if (this.profile.roles[0] === 12 || this.profile.roles[0] === 13) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    toggleAccordion(firm) {
      let acc = document.getElementById(`accordion-${firm}`)
      acc.classList.toggle('accordion-active')
      let accPanel = document.getElementById(`panel-${firm}`)
      if (accPanel.style.maxHeight) {
        accPanel.style.maxHeight = null
      } else {
        accPanel.style.maxHeight = accPanel.scrollHeight + 'px'
      }
    },
    refreshChannels() {
      let $this = this
      setTimeout(() => {
        // console.log('Refreshing Chat Channels', {
        //   channels: $this.channels,
        //   firmCounts: $this.firmCounts
        // })
        $this.isRender += 1
        $this.$forceUpdate()
      }, 200)
    },
    firmChannels(firm) {
      let channels = []
      if (this.channels) {
        channels = this.channels.filter(x => x.firm === firm.firm)
      }
      return channels
    },
    vehicleInfo(item) {
      let data = null
      if (item) {
        data = `${item.year} ${item.make} ${item.model}`
      }
      return data
    },
    showMessages(item) {
      this.$emit('showMessages', item)
    },
    closeChannels() {
      this.$emit('closeChannels')
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('chat-refresh-groups')
  }
}
</script>
<style lang="scss" scoped>
.custom-chat-channels {
  background-color: #98d9f7;
  border: 1px solid #c8c8cd;
  padding-top: 2px;
}
.custom-group-title {
  text-align: center;
  font-weight: 600;
  font-size: 1.1em;
  margin-right: 0;
  margin-left: 0;
}
.custom-close {
  cursor: pointer;
}
.custom-row {
  margin-left: 2px;
  margin-right: 2px;
  border-bottom: 1px solid #c8c8cd;
  cursor: move;
}
.custom-group-row {
  margin-left: 2px;
  margin-right: 2px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 92%;
}
.page-content {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  height: 100%;
  position: relative;
  z-index: 1;
  padding-top: 5px;
  padding-bottom: 5px;
}
.channels-content,
.channels {
  background: #fff;
}
.group {
  border: 1px solid #c8c8cd;
  border-radius: 2px;
  background-color: #f0f0f0;
  min-height: 64px;
  margin-bottom: 5px;
  cursor: pointer;
  :hover {
    background-color: #b5bdd4;
  }
}
.group-content {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 5px;
}
.group-info {
  .group-member-count {
    margin-left: 4px;
  }
}
.group-name {
  line-height: 1;
  color: #000000;
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 2px;
}
.group-footer {
  position: relative;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8em;
  width: 100%;
  .group-created {
    float: right;
  }
}
.custom-unread {
  position: absolute;
  right: 5px;
  top: 5px;
}
.custom-accordion {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/chat-groups.vue